const mbFileSize = 10;
export const MaxFileSize = mbFileSize * 1024 * 1024;

export const cdnErrors = {
  delete: "Error on deleting asset",
  notSupported: "File type not supported",
  hasSameName:
    "File with the same name already exists. Please use refresh button to replace the file.",
  hasDifferentType: "File type is different from the original file.",
  parseFail: "File cannot be parsed",
  tooBig: `File size should be less than ${mbFileSize}MB`,
};
